<template>
  <div v-if="category" class="page-wrapper container-custom">
    <div class=" category-heading">
      <TitlesDescriptionComponent :size="'small'" :title="category.title"/>
    </div>
    <div class=" row g-0 services-wrapper">
      <div v-for="(category, index) in category.services" :key="index" class="one-service">
        <router-link :to="{name: 'OneServiceView', params: { id: category.id } }">
          <OneServiceCategoryButton :buttonIcon="category.icon" :buttonText="category.title"
                                    :buttonTextHover="$t('learn-more')" :theme="'solid-grey'"/>
        </router-link>
      </div>
    </div>
    <div class=" additional-info-wrapper d-flex justify-content-center align-items-center">
      <div>
        <div class="mb-2 title "> {{ $t('one-category-bottom-title') }}</div>
        <div class="mb-4 subtitle"> {{ $t('one-category-bottom-subtitle') }}</div>
        <div class="d-flex justify-content-center">
          <div class="col-md-5 col-12">
            <router-link :to="{name: 'ContactsView' }">
              <MainButton :button-text="$t('contact-us')" :icon="'arrow-forward'" :size="'medium'"
                          :theme="'solid-blue'"/>
            </router-link>
          </div>


        </div>

      </div>
    </div>
  </div>
</template>

<script>
import TitlesDescriptionComponent
  from "@/components/Components/TitlesDescriptionComponent/TitlesDescriptionComponent.vue";
import OneServiceCategoryButton from "@/components/Common/Buttons/OneServiceCategoryButton.vue";
import MainButton from "@/components/Common/Buttons/MainButton.vue";

export default {
  name: 'OneCategoryView',
  components: {
    MainButton,
    OneServiceCategoryButton,
    TitlesDescriptionComponent,
  },
  data() {
    return {
      category: null,
    };
  },
  async mounted() {
    const id = this.$route.params.id;

    this.category = await this.$store.dispatch("categories/getCategory", {id});
  }

};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/fonts.scss";

.page-wrapper {
  font-family: $font-regular;
}

.category-heading {
  margin-top: 90px;

}

.services-wrapper {

  padding-top: $spacing-6;
  padding-bottom: $spacing-6;
  margin-bottom: $spacing-4;

  .one-service {
    margin: $spacing-1 0;
  }
}

.additional-info-wrapper {
  background: $color-blue-light;
  border-radius: 30px;
  padding: $spacing-5 25px;
  color: $color-brown;
  text-align: center;
  margin-bottom: $spacing-10;

  .title {
    font-size: $subtitle-1;
    font-family: $font-bold;

  }

  .subtitle {
    font-size: $paragraph-1;
  }
}

@media screen and (min-width: 768px) {
  .category-heading {
    margin-top: 100px;
  }
  .services-wrapper {
    margin-bottom: $spacing-9;
  }
  .additional-info-wrapper {
    padding: $spacing-9;
    border-radius: 50px;

    .title {
      font-size: $title-h5;
    }
  }


}
</style>